import { Routes } from '@angular/router';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
  { path: '', loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent) },
  { path: 'login', loadComponent: () => import('./pages/admin/login/admin-login.component').then(m => m.AdminLoginComponent) },
  { path: 'register', redirectTo: '/login', pathMatch: 'full' },
  { path: 'forgot-password', loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent) },
  { path: 'reset-password', loadComponent: () => import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent) },
  {
    path: 'admin',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/admin/layout/admin-layout.component').then(m => m.AdminLayoutComponent),
        canActivate: [adminGuard],
        children: [
          { path: '', loadComponent: () => import('./pages/admin/dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent) },
          { path: 'tools', loadComponent: () => import('./pages/admin/tools-list/tools-list.component').then(m => m.ToolsListComponent) },
          { path: 'tools/:id', loadComponent: () => import('./pages/admin/tool-detail/tool-detail.component').then(m => m.ToolDetailComponent) },
          { path: 'tools/:id/email-templates', loadComponent: () => import('./pages/admin/email-templates/email-templates.component').then(m => m.EmailTemplatesComponent) },
          { path: 'payments', loadComponent: () => import('./pages/admin/payments-list/payments-list.component').then(m => m.PaymentsListComponent) },
          { path: 'subscriptions', loadComponent: () => import('./pages/admin/subscriptions-list/subscriptions-list.component').then(m => m.SubscriptionsListComponent) },
          { path: 'invoices', loadComponent: () => import('./pages/admin/invoices-list/invoices-list.component').then(m => m.InvoicesListComponent) },
          { path: 'invoices/:id', loadComponent: () => import('./pages/admin/invoice-detail/invoice-detail.component').then(m => m.InvoiceDetailComponent) },
          { path: 'crons', loadComponent: () => import('./pages/admin/crons-list/crons-list.component').then(m => m.CronsListComponent) },
          { path: 'crons/new', loadComponent: () => import('./pages/admin/cron-form/cron-form.component').then(m => m.CronFormComponent) },
          { path: 'crons/:id/edit', loadComponent: () => import('./pages/admin/cron-form/cron-form.component').then(m => m.CronFormComponent) },
        ],
      },
    ],
  },
];
